import { Box } from "@mui/material";
import { Suspense } from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom"; //HashRouter
import AutorenewIcon from "@mui/icons-material/Autorenew";
//lazy load components
import ProtectedRoute from "../ProtectedRoute";
import Fallback from "../pages/Fallback/Fallback";
import Login from "../pages/Signin/Login";
import Dashboard from "../pages/Dashboard/Dashboard";
import AppLayout from "./AppLayout";
import ProductsList from "../pages/Products/ProductsList";
import LocationList from "../pages/Location/LocationList";
import Location from "../pages/Location/Location";
import ReceivedStock from "../pages/Dashboard/ReceivedStock";
import NewStock from "../pages/Dashboard/NewStock";
import ReturnedStock from "../pages/Dashboard/ReturnedStock";
import DispatchStock from "../pages/Dashboard/DispatchStock";
import TransferStock from "../pages/Dashboard/TransferStock";
import AisleList from "../pages/Aisles/AisleList";
import Aisle from "../pages/Aisles/Aisle";
import ProductLocationList from "../pages/ProductLocations/ProductLocationList";
import ProductLocation from "../pages/ProductLocations/ProductLocation";
import Scan from "../pages/Scan/Scan";
import Product from "../pages/Products/Product";
import RostersList from "../pages/Rosters/RostersList";
import User from "../pages/Users/User";
import UserList from "../pages/Users/UserList";
import HelperList from "../pages/Helper/HelperList";
import Helper from "../pages/Helper/Helper";
import ResolveHelperReminder from "../pages/Reminders/HelperReminders/ResolveHelperReminder";
import EditHelperReminder from "../pages/Reminders/HelperReminders/EditHelperReminder";
import AddHelperReminder from "../pages/Reminders/HelperReminders/AddHelperReminder";
import HelperReminders from "../pages/Reminders/HelperReminders/HelperReminders";
import Roster from "../pages/Rosters/Roster";
import ReceiveReturnedStock from "../pages/Dashboard/ReceiveReturnedStock";
import FileImport from "../pages/FileImports/FileImport";
import TransactionsSaleOrder from "../pages/Transactions/TransactionsSaleOrder";
import TransactionsCreditNote from "../pages/Transactions/TransactionsCreditNote";
import TransactionsOpeningBalance from "../pages/Transactions/TransactionsOpeningBalance";
import TransactionsPurchaseOrder from "../pages/Transactions/TransactionsPurchaseOrder";
import TransactionsPurchaseOrderList from "../pages/Transactions/TransactionsPurchaseOrderList";
import TransactionsOpeningBalanceList from "../pages/Transactions/TransactionsOpeningBalanceList";
import TransactionsSaleOrderList from "../pages/Transactions/TransactionsSaleOrderList";
import TransactionsCreditNoteList from "../pages/Transactions/TransactionsCreditNoteList";
import RoutePacking from "../pages/Dashboard/RoutePacking";
import PalletInfo from "./PublicPalletInfo/PalletInfo";
import RoutePicking from "../pages/Dashboard/RoutePicking";
import CountCyclesList from "../pages/CountCycles/CycleCountList";
import CountCycles from "../pages/CountCycles/CycleCount";
import CycleCountList from "../pages/CountCycles/CycleCountList";
import CycleCount from "../pages/CountCycles/CycleCount";
import UpdateCycleCount from "../pages/CountCycles/UpdateCycleCount";
import MainDashboard from './Dashboard';

import InventoryAdjustment from "../pages/Transactions/InventoryAdjustment";
import InventoryAdjustmentList from "../pages/Transactions/InventoryAdjustmentList";
import StockTrail from "../pages/Reports/StockTrail/StockTrail";
import Pin from "../pages/Pin/Pin";
import TransferStockList from "../pages/Transactions/TransferStockList";
import TransferStockDetails from "../pages/Transactions/TransferStockDetails";
import RouteReturns from "../pages/Dashboard/RouteReturns";
import RouteInventoryAdjustment from "../pages/Dashboard/RouteInventoryAdjustment";
import BatchReport from "../pages/Reports/BatchReports/BatchReport";
import AlertList from "../pages/Alerts/AlertList";
export default function App() {
  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <Box
            style={{
              display: "block",
              width: "100%",
              textAlign: "center",
              paddingTop: "10%",
            }}
          >
            <AutorenewIcon />
          </Box>
        }
      >
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/pallet-info/:id" element={<PalletInfo />} />
          <Route path="/pin" element={<Pin />} />

          <Route element={<AppLayout />}>
            <Route
              path="/stocks"

              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute>
                  <UserList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/user/:id"
              element={
                <ProtectedRoute>
                  <User />
                </ProtectedRoute>
              }
            />

            <Route
              path="/migrations"
              element={
                <ProtectedRoute>
                  <FileImport />
                </ProtectedRoute>
              }
            />

            <Route
              path="/transaction-so"
              element={
                <ProtectedRoute>
                  <TransactionsSaleOrderList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/transaction-so/:id"
              element={
                <ProtectedRoute>
                  <TransactionsSaleOrder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/transaction-po"
              element={
                <ProtectedRoute>
                  <TransactionsPurchaseOrderList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/transaction-po/:id"
              element={
                <ProtectedRoute>
                  <TransactionsPurchaseOrder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/transaction-cn"
              element={
                <ProtectedRoute>
                  <TransactionsCreditNoteList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/transaction-cn/:id"
              element={
                <ProtectedRoute>
                  <TransactionsCreditNote />
                </ProtectedRoute>
              }
            />
            <Route
              path="/transaction-ob"
              element={
                <ProtectedRoute>
                  <TransactionsOpeningBalanceList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/transaction-ob/:id"
              element={
                <ProtectedRoute>
                  <TransactionsOpeningBalance />
                </ProtectedRoute>
              }
            />
            <Route
              path="/transaction-inventory/:id"
              element={
                <ProtectedRoute>
                  <InventoryAdjustment />
                </ProtectedRoute>
              }
            />
            <Route
              path="/transaction-inventory"
              element={
                <ProtectedRoute>
                  <InventoryAdjustmentList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/transaction-transfer"
              element={
                <ProtectedRoute>
                  <TransferStockList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/transaction-transfer/:id"
              element={
                <ProtectedRoute>
                  <TransferStockDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports-stock-trail"
              element={
                <ProtectedRoute>
                  <StockTrail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports-batches"
              element={
                <ProtectedRoute>
                  <BatchReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/helpers"
              element={
                <ProtectedRoute>
                  <HelperList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/helpers/:id"
              element={
                <ProtectedRoute>
                  <Helper />
                </ProtectedRoute>
              }
            />
            <Route
              path="/helper_reminder"
              element={
                <ProtectedRoute>
                  <HelperReminders />
                </ProtectedRoute>
              }
            />
            <Route
              path="/helper_reminder/new"
              element={
                <ProtectedRoute>
                  <AddHelperReminder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/helper_reminder/:id"
              element={
                <ProtectedRoute>
                  <EditHelperReminder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/helper_reminder/resolve/:id"
              element={
                <ProtectedRoute>
                  <ResolveHelperReminder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/products"
              element={
                <ProtectedRoute>
                  <ProductsList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/products/:id"
              element={
                <ProtectedRoute>
                  <Product />
                </ProtectedRoute>
              }
            />
            <Route
              path="/locations"
              element={
                <ProtectedRoute>
                  <LocationList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/locations/:id"
              element={
                <ProtectedRoute>
                  <Location />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cycle-counts"
              element={
                <ProtectedRoute>
                  <CycleCountList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/alerts"
              element={
                <ProtectedRoute>
                  <AlertList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cycle-counts/:id"
              element={
                <ProtectedRoute>
                  <CycleCount />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cycle-counts/update/:id"
              element={
                <ProtectedRoute>
                  <UpdateCycleCount />
                </ProtectedRoute>
              }
            />

            <Route
              path="/rosters"
              element={
                <ProtectedRoute>
                  <RostersList />
                </ProtectedRoute>
              }
            />

            <Route
              path="/rosters/:id"
              element={
                <ProtectedRoute>
                  <Roster />
                </ProtectedRoute>
              }
            />

            <Route
              path="/stocks/route-packing"
              element={
                <ProtectedRoute>
                  <RoutePacking />
                </ProtectedRoute>
              }
            />

            <Route
              path="/stocks/route-picking"
              element={
                <ProtectedRoute>
                  <RoutePicking />
                </ProtectedRoute>
              }
            />

            <Route
              path="/stocks/receive-stock"
              element={
                <ProtectedRoute>
                  <ReceivedStock />
                </ProtectedRoute>
              }
            />
            <Route
              path="/stocks/receive-returned-stock"
              element={
                <ProtectedRoute>
                  <ReceiveReturnedStock />
                </ProtectedRoute>
              }
            />
            <Route
              path="/stocks/new-stock"
              element={
                <ProtectedRoute>
                  <NewStock />
                </ProtectedRoute>
              }
            />
            <Route
              path="/stocks/returned-stock"
              element={
                <ProtectedRoute>
                  <ReturnedStock />
                </ProtectedRoute>
              }
            />
            <Route
              path="/stocks/route-returns"
              element={
                <ProtectedRoute>
                  <RouteReturns />
                </ProtectedRoute>
              }
            />
           
            <Route
              path="/stocks/dispatch-stock"
              element={
                <ProtectedRoute>
                  <DispatchStock />
                </ProtectedRoute>
              }
            />
            <Route
              path="/stocks/transfer-stock"
              element={
                <ProtectedRoute>
                  <TransferStock />
                </ProtectedRoute>
              }
            />
            <Route
              path="/stocks/inventory-adjustments"
              element={
                <ProtectedRoute>
                  <RouteInventoryAdjustment />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <MainDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/aisles"
              element={
                <ProtectedRoute>
                  <AisleList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/aisles/:id"
              element={
                <ProtectedRoute>
                  <Aisle />
                </ProtectedRoute>
              }
            />
            <Route
              path="/product-locations"
              element={
                <ProtectedRoute>
                  <ProductLocationList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/product-locations/:id"
              element={
                <ProtectedRoute>
                  <ProductLocation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/scan"
              element={
                <ProtectedRoute>
                  <Scan />
                </ProtectedRoute>
              }
            />

            <Route
              path="*"
              element={
                <Fallback />
              }
            />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
